import { isTypeContentPageHeader } from '@platform/contentful';
import { Entry } from 'contentful';
import Divider from './util/Divider';
import MarkdownText from './util/MarkdownText';

const ContentfulContentPageHeader = ({
  entry,
  tocItems,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
  /* The strings to render in the inline table of contents that only displays in mobile resolutions
   * This will be undefined if this ContentfulPageHeader isn't a direct child of <ContentfulPage>, but
   * the current (Sept 2025) ToC setup requires that hierarchy in order to function. */
  tocItems?: string[];
}) => {
  if (!entry || !isTypeContentPageHeader(entry)) {
    return null;
  }

  return (
    <div className='bg-white sm:max-w-screen sm:-mx-2'>
      {/* Unfortuantely these pages rely on rendering the cover image as the bkg to a div
       * and then _partially_ masking it at the bottom */}
      <div
        className='z-0 absolute top-0 left-0 w-full h-[75vh] min-h-[50vh] bg-cover bg-center'
        style={{
          backgroundImage:
            entry.fields.image ?
              `url(https:${entry.fields.image.fields.file?.url}?fit=fill&w=1920&h=1280)`
            : undefined,
        }}
      />
      {/* This 'pb-5 -mb-5 sm:pb-10 sm:-mb-10' is a bad hack to force extending the bottom of this header down to mask the bkg image,
       * without actually offsetting the content */}
      <div className='relative mt-[50vh] sm:pt-12 w-full bg-white pb-5 -mb-5 sm:pb-10 sm:-mb-10'>
        <div className='sm:max-w-[600px] sm:mx-auto relative bg-white -mx-2 pb-5 -mb-5 px-2 pt-6 flex flex-col gap-2'>
          <h1 className='my-3 text-4xl sm:text-5xl font-header sm:leading-14 font-bold text-gray-500'>
            {entry.fields.header}
          </h1>
          <p className='text-xl sm:text-2xl font-header'>{entry.fields.subHeader}</p>
          <Divider />
          <MarkdownText text={entry.fields.description} />
          {entry.fields.description && <Divider />}
          {/* Desktop version is rendered in ContentfulPage */}
          <div className='block sm:hidden'>
            {entry.fields.tableOfContents &&
              tocItems?.map((item) => (
                <a
                  key={item}
                  href={
                    // Ensure window exists before use to avoid crashing the Vite build for static pages
                    typeof window !== 'undefined' ?
                      `${window.location.pathname}#${item.replaceAll(' ', '_')}`
                    : ''
                  }
                  className='blue-link'
                >
                  {item}
                </a>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentfulContentPageHeader;
